const mainUl = document.querySelector(".header__nav ul");
const uls = document.querySelectorAll(".header__navor ul");
const navor = document.querySelector(".header__navor");

const setPos = () => {
    uls.forEach((ul) => {
        const myLi = mainUl.querySelector(`[data-index="${ul.dataset.index}"]`);

        if (myLi) {
            ul.style.left = `${
                myLi.getBoundingClientRect().left +
                myLi.getBoundingClientRect().width / 2
            }px`;
        }
    });
};

setPos();

let resizeTimeout;

window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        setPos();
    }, 200);
});

let hoveringTimeout;
let isHovering = false;
let isInViewport = true;

const closeOr = () => {
    uls.forEach((ul) => {
        ul.classList.remove("is-on");
    });
    navor.classList.remove("is-on");
};

const scroll = () => {
    const mainUlInfo = mainUl.getBoundingClientRect();
    isInViewport = mainUlInfo.top > 0 && mainUlInfo.bottom < innerHeight;

    uls.forEach((ul) => {
        ul.style.translate = `-50% ${
            -window.pageYOffset || -document.documentElement.scrollTop
        }px`;
    });

    if (!isInViewport) {
        closeOr();
    }
};
scroll();

window.addEventListener("scroll", scroll);

const setIsHovering = (state) => {
    // console.log(isHovering);
    isHovering = state;

    if (!state) {
        clearTimeout(hoveringTimeout);
        hoveringTimeout = setTimeout(() => {
            closeOr();
        }, 333);
    } else {
        clearTimeout(hoveringTimeout);
    }
};

const lis = mainUl.querySelectorAll("li.links");
lis.forEach((li) => {
    li.addEventListener("mouseenter", () => {
        setIsHovering(true);
        closeOr();
        const targetUl = Array.from(uls).find(
            (ul) => ul.dataset.index === li.dataset.index
        );
        targetUl.classList.add("is-on");
        navor.classList.add("is-on");
        // console.log("li mouseenter");
    });

    uls.forEach((ul) => {
        ul.addEventListener("mouseenter", (e) => {
            if (e.target === e.currentTarget) setIsHovering(true);
            // console.log(e, "ul mouseenter");
        });

        ul.addEventListener("mouseleave", (e) => {
            if (e.target === e.currentTarget) setIsHovering(false);
            // console.log(e, "ul mouseleave");
        });
    });

    li.addEventListener("mouseleave", () => {
        setIsHovering(false);
        // console.log("li mouseleave");
    });
});
